import { Injectable, OnDestroy } from '@angular/core';
import { AuthRepository } from './auth.repository';
import { JwtRefreshService } from './jwt-refresh.service';
import { AuthUtils } from './auth.utils';

@Injectable({ providedIn: 'root' })
export class TokenMonitorService implements OnDestroy {
  private checkInterval = 60000; // 1 minute
  private intervalId: any;
  private isMonitoring = false;

  constructor(
    private authRepository: AuthRepository,
    private jwtRefreshService: JwtRefreshService
  ) {}

  /**
   * Start monitoring token expiry
   */
  startMonitoring(): void {
    if (this.isMonitoring) {
      console.log('Token monitoring already active');
      return;
    }

    console.log('Starting token expiry monitoring');
    this.isMonitoring = true;
    
    // Check immediately
    this.checkTokenExpiry();
    
    // Then check every minute
    this.intervalId = setInterval(() => {
      this.checkTokenExpiry();
    }, this.checkInterval);
  }

  /**
   * Stop monitoring token expiry
   */
  stopMonitoring(): void {
    if (this.intervalId) {
      console.log('Stopping token expiry monitoring');
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.isMonitoring = false;
  }

  /**
   * Check if monitoring is active
   */
  isActive(): boolean {
    return this.isMonitoring;
  }

  /**
   * Check token expiry and refresh if needed
   */
  private async checkTokenExpiry(): Promise<void> {
    const token = this.authRepository.getAccessToken();
    if (!token) {
      console.log('No access token found, stopping monitoring');
      this.stopMonitoring();
      return;
    }

    // Check if token is expired or will expire in the next 5 minutes
    const isExpired = AuthUtils.isTokenExpired(token, 300); // 5 minutes buffer
    if (isExpired) {
      console.log('Token expired or expiring soon, attempting refresh...');
      
      try {
        const refreshed = await this.jwtRefreshService.refreshToken();
        if (!refreshed) {
          console.log('Token refresh failed, stopping monitoring');
          this.stopMonitoring();
        }
      } catch (error) {
        console.error('Error during token refresh:', error);
        this.stopMonitoring();
      }
    }
  }

  /**
   * Force a token check
   */
  async forceCheck(): Promise<void> {
    await this.checkTokenExpiry();
  }

  /**
   * Cleanup on destroy
   */
  ngOnDestroy(): void {
    this.stopMonitoring();
  }
}








